import { render, staticRenderFns } from "./ResourceWidget.vue?vue&type=template&id=5dbfebc8&scoped=true&"
import script from "./ResourceWidget.vue?vue&type=script&lang=js&"
export * from "./ResourceWidget.vue?vue&type=script&lang=js&"
import style0 from "./ResourceWidget.vue?vue&type=style&index=0&id=5dbfebc8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5dbfebc8",
  null
  
)

export default component.exports